import { render, staticRenderFns } from "./CategoryFirstList.vue?vue&type=template&id=c6554e04&scoped=true&"
import script from "./CategoryFirstList.vue?vue&type=script&lang=js&"
export * from "./CategoryFirstList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFirstList.vue?vue&type=style&index=0&id=c6554e04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6554e04",
  null
  
)

export default component.exports